<div class="nav-plan-wrapper"
  [ngClass]="{
    'hide-navigation-plan': mobileVisiblePanel() == 'car'
  }">

  <div class="np-card" #npCard>

    <!-- Recalculating status: a small badge on the card's top edge, so the
         card itself never changes height while a replan is in flight. -->
    @if (recalculating()) {
      <div class="np-recalc" role="status" aria-live="polite" data-testid="nav-plan-recalc-badge">
        <span class="np-recalc-spinner" aria-hidden="true"></span>
        <span class="np-recalc-label">{{ languageService.languageJSON.NavigationHud_Recalculating }}</span>
      </div>
    }

    <!-- Better route offer: takes the whole card over, like the charging stop -->
    @if (betterRouteVisible()) {
      <app-navigation-plan-better-route
        [message]="betterRouteMessage()"
        [timeoutMs]="betterRouteTimeoutMs"
        (acceptClick)="acceptBetterRoute()"
        (dismissClick)="dismissBetterRoute()">
      </app-navigation-plan-better-route>
    }

    @if (!betterRouteVisible()) {
      <!-- Normal navigation: swipeable pages with skip / stop icon buttons -->
      @if (chargeState() == ChargeState.None) {
        <app-navigation-plan-normal-state
          [computersArray]="computersArray()"
          [estimatedBatteryLevel]="estimatedBatteryLevel()"
          [cannotSkipMoreChargingStation]="CannotSkipMoreChargingStation()"
          (skipWaypointClick)="skipWaypoint()"
          (skipChargingStationClick)="skipChargingStation()"
          (stopNavigationClick)="stopNavigation()"
          (batteryReservedWarningClick)="openBatteryReservedSnackbar()">
        </app-navigation-plan-normal-state>
      }

      <!-- Charge state UI (preserved from legacy) -->
      @if (chargeState() != ChargeState.None) {
        <app-navigation-plan-header
          [chargeState]="chargeState()"
          [chargerName]="arrivedChargerDetails()?.Name ?? ''">
        </app-navigation-plan-header>

        <app-navigation-plan-charge-state
          [arrivedAtMessage]="arrivedAtMessage()"
          [arrivedChargerDetails]="arrivedChargerDetails()"
          [chargeTime]="chargeTime()"
          [chargeState]="chargeState()"
          [arrivedChargerIsEndpoint]="arrivedChargerIsEndpoint()"
          (startChargeClick)="startCharge()"
          (replanNavigationClick)="replanNavigation()"
          (stopNavigationClick)="stopNavigation()"
          (finishChargeClick)="finishCharge()">
        </app-navigation-plan-charge-state>
      }
    }
  </div>
</div>
